import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { SmartFilter } from '../../components/common/SmartFilter';
import { headerRequestTable } from '../../utils/constants';
import Pagination from '../../components/atoms/Pagination';
import { debounce } from '../../utils/helper';
import {
  TechnicianKycStatus,
  TechnicianStatus,
  TechnicianType,
} from '../../utils/entities/type';
import { AddEditTechnicianModal } from '../../components/ui/add/technicianModal';
import { ToolRequestList } from '../../components/ui/list/ToolRequestList';
import { GetRequestList } from '../../services/toolRequest';
import AddRequestModal from './AddToolRequestModal';

export interface TechnicianFilterData {
  type: TechnicianType | any;
  position: '';
  status: TechnicianStatus | any;
  kycStatus: TechnicianKycStatus | any;
}

const ToolRequest = () => {
  const [page, setPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [technicians, setTechnicians] = useState('');
  const [totalTechnician, setTotalTechnician] = useState(0);
  const [searchQuery, setSearchQuery] = useState<string | undefined>(undefined);
  const [openAddModal, setOpenAddModal] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchTechnician(page, rowsPerPage, searchQuery);
  }, [page, rowsPerPage, searchQuery]);

  const fetchTechnician = async (
    page: number,
    limit: number,
    searchQuery?: string,
  ) => {
    try {
      setIsLoading(true);
      const response = await GetRequestList({
        page,
        limit,
        searchQuery,
      });

      setTechnicians(response.data);
      setTotalTechnician(response.count);
    } catch (error) {
      console.error('Failed to fetch technicians:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const refreshList = () => {
    console.log('REFRESHLIST HAPPED');
    fetchTechnician(page, rowsPerPage, searchQuery);
  };

  const handleSearchRefresh = debounce((search: string) => {
    setSearchQuery(search);
    setPage(1);
  }, 500);

  const handleAddModal = () => {
    setOpenAddModal(true);
  };
  const handleSaveRefresh = () => {
    refreshList();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        maxHeight: '100%',
      }}
    >
      <SmartFilter
        title="Request Tools"
        createFilter={['SEARCH', 'ADD']}
        addDrawerSize="lg"
        filterdrawerSize="sm"
        filterHeader={'Filter Technicians'}
        addHeader={'Add Request'}
        addbuttontitle="Add Request"
        onSearch={handleSearchRefresh}
        onSaved={refreshList}
        onNavigate={handleAddModal}
      />
      {openAddModal && (
        <AddRequestModal
          open={openAddModal}
          onClose={() => setOpenAddModal(false)}
          onSave={() => {
            handleSaveRefresh();
            setOpenAddModal(false);
          }}
        />
      )}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minHeight: 0,
          p: 1,
        }}
      >
        <Box
          sx={{
            height: '100%',
            maxHeight: '100%',
            overflowY: 'scroll',
            scrollbarWidth: 'none',
          }}
        >
          {technicians.length <= 0 && !isLoading ? (
            <Typography textAlign={'center'} marginTop={'20%'}>
              No Technicians Found
            </Typography>
          ) : (
            <ToolRequestList
              headerCells={headerRequestTable}
              technicians={technicians}
              isLoading={isLoading}
              onUpdate={refreshList}
            />
          )}
        </Box>

        <Box display={'block'} bottom={0} right={0}>
          <Pagination
            count={totalTechnician}
            page={page - 1}
            rowsPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ToolRequest;
